module.exports = __webpack_public_path__ + "media/images/qml_file-97c3d8db0e5e374784dcc73c9aa7430c.png";